module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "book"
  }, [_c('div', {
    staticClass: "coverInfo"
  }, [_c('img', {
    staticClass: "coverImage",
    attrs: {
      "src": "//textcafe.co/books/CRTYPu/tc-custom/FC-9781528955799.jpg?1692013024797?1709061462324",
      "alt": "This image is the cover for the book Of Woe, Wonder and Whimsy"
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "bookInfo"
  }, [_c('h1', {
    staticClass: "bookTitle heading font1"
  }, [_vm._v("Of Woe, Wonder and Whimsy\n    ")]), _vm._v(" "), _c('p', {
    staticClass: "bookDescription body article font2"
  }), _c('p', [_vm._v("Thirteen tales as they were told to me on wild, wet and windy nights, throughout one raw winter not so very long ago. I was compelled to write them down and have duly done so loyally and without undue exaggeration towards time and place. Above all, the characters within these pages lived, and many still do, in a rapidly changing landscape. These tales blossomed in and around the once-isolated villages of Ripponden and Rishworth, of Calderdale, West Yorkshire. But on looking at them, they might well have sprung to life almost anywhere. So make of them what you will. For a tale is but a tale after all, and needn't be believed. It is up to you, the reader, to decide!")]), _vm._v(" "), _c('p')]), _vm._v(" "), _c('div', {
    staticClass: "authorInfo"
  }, [_c('h2', {
    staticClass: "authorName heading font1"
  }, [_vm._v("\n      D. E. Ceit\n    ")]), _vm._v(" "), _c('p', {
    staticClass: "authorDescription body article"
  }, [_vm._v("Ex-teacher, university sports officer and tour guide, who took to writing when a teenager and who then got ambushed by marriage, divorce and life in general before deciding to write a miscellaneous collection of short stories.")])]), _vm._v(" "), _c('div', {
    staticClass: "publisherInfo"
  }, [_c('h2', {
    staticClass: "publisherName heading font1"
  }, [_vm._v("\n    Austin Macauley Publishers\n   ")])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-638a3f51","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/home.vue
// module id = 51
// module chunks = 0